import React from 'react';
import Select from 'react-select';
import {
  DropdownIndicator,
  customStyles,
  ControlComponent,
} from 'app/components/ExploreSelect/styles';

interface ExploreSelectProps {
  options: { value: string; label: string | React.ReactNode }[];
  isSingle?: boolean;
  placeholder: string;
  defaultValue?:
    | { value: string; label: string | React.ReactNode }
    | { value: string; label: string }[];
  value?:
    | { value: string; label: string }
    | { value: string; label: string }[]
    | null;
  onMenuOpen?: () => void;
  onChange?: (v: any, a: any) => void;
  isLoading?: boolean;
  width: string;
  isSearchable?: boolean;
}
export const ExploreSelect = (props: ExploreSelectProps) => {
  return (
    <Select
      styles={{
        ...customStyles,
        valueContainer: (provided: any) => ({
          ...provided,
          width: props.width,
          padding: 6,
        }),
      }}
      isMulti={!props.isSingle}
      defaultValue={props.defaultValue ? props.defaultValue : null}
      value={props.value ? props.value : undefined}
      hideSelectedOptions={false}
      components={{ DropdownIndicator, Control: ControlComponent }}
      {...props}
    />
  );
};
